
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as indexA8Vyh6RN5rMeta } from "/Applications/FE/front/paxgon/pages/about/index.vue?macro=true";
import { default as indexQTuCe4PXWUMeta } from "/Applications/FE/front/paxgon/pages/concat/index.vue?macro=true";
import { default as index1TSq74k4TfMeta } from "/Applications/FE/front/paxgon/pages/index.vue?macro=true";
import { default as _91id_93UwLLt09yUMMeta } from "/Applications/FE/front/paxgon/pages/industry/detail/[id].vue?macro=true";
import { default as indexJ4MAXV5p1XMeta } from "/Applications/FE/front/paxgon/pages/industry/index.vue?macro=true";
import { default as index8hbUFJWSlMMeta } from "/Applications/FE/front/paxgon/pages/ourpartners/index.vue?macro=true";
import { default as _91id_93sNjdGyjMveMeta } from "/Applications/FE/front/paxgon/pages/ourwork/detail/[id].vue?macro=true";
import { default as indexLRxsgk70UjMeta } from "/Applications/FE/front/paxgon/pages/ourwork/index.vue?macro=true";
import { default as indexDSaJv1NMC8Meta } from "/Applications/FE/front/paxgon/pages/service/index.vue?macro=true";
export default [
  {
    name: "about",
    path: "/about",
    component: () => import("/Applications/FE/front/paxgon/pages/about/index.vue")
  },
  {
    name: "concat",
    path: "/concat",
    component: () => import("/Applications/FE/front/paxgon/pages/concat/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/Applications/FE/front/paxgon/pages/index.vue")
  },
  {
    name: "industry-detail-id",
    path: "/industry/detail/:id()",
    component: () => import("/Applications/FE/front/paxgon/pages/industry/detail/[id].vue")
  },
  {
    name: "industry",
    path: "/industry",
    component: () => import("/Applications/FE/front/paxgon/pages/industry/index.vue")
  },
  {
    name: "ourpartners",
    path: "/ourpartners",
    component: () => import("/Applications/FE/front/paxgon/pages/ourpartners/index.vue")
  },
  {
    name: "ourwork-detail-id",
    path: "/ourwork/detail/:id()",
    component: () => import("/Applications/FE/front/paxgon/pages/ourwork/detail/[id].vue")
  },
  {
    name: "ourwork",
    path: "/ourwork",
    component: () => import("/Applications/FE/front/paxgon/pages/ourwork/index.vue")
  },
  {
    name: "service",
    path: "/service",
    component: () => import("/Applications/FE/front/paxgon/pages/service/index.vue")
  }
]